import { resolveHolyWheelSource } from "../logic/helpers/holyWheelSource";

export const HOLY_WHEEL_SOURCE = resolveHolyWheelSource(
    import.meta.env.VITE_HOLY_WHEEL_SOURCE,
    import.meta.env.PROD,
);
